import { Controller } from "@hotwired/stimulus"

// Makes a whole table row navigate to a detail page on click. The target URL
// loads into the global #content turbo-frame so it advances history exactly
// like the in-row "View" link. Clicks on interactive elements inside the row
// (links, buttons, inputs, selects, labels, or anything marked
// data-row-link-ignore — e.g. the actions dropdown) are ignored so per-row
// controls keep working.
export default class extends Controller {
  static values = {
    url: String,
    frame: { type: String, default: "content" },
  }

  navigate(event) {
    if (event.target.closest("a, button, input, select, label, [data-row-link-ignore]")) return

    const frame = document.getElementById(this.frameValue)
    if (!frame) {
      window.location.assign(this.urlValue)
      return
    }

    // Drive a real Turbo frame link rather than assigning frame.src directly:
    // a programmatic src change loads the content but doesn't promote the URL
    // (advance history), so Back/Forward and the address bar get out of sync.
    // A synthetic link click navigates the frame exactly like the nav links do.
    const link = document.createElement("a")
    link.href = this.urlValue
    link.setAttribute("data-turbo-frame", this.frameValue)
    link.setAttribute("data-turbo-action", "advance")
    link.hidden = true
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
